import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { BookOpen } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { generatePath, useLocation, useNavigate } from 'react-router';
import { ROUTES } from 'constants/routes';
import { type Appointment } from 'types/appointments';

export const FutureAppointmentsActions = ({
  appointment,
}: {
  appointment: Appointment;
}): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.PSYCHOLOGIST);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const handleViewAppointment = (): void => {
    navigate(
      generatePath(ROUTES.PATIENT_APPOINTMENTS, {
        id: appointment.patientId,
        appointmentId: appointment.id,
      }),
      { state: { appointment, from: pathname } }
    );
  };
  return (
    <Button
      variant="terciary"
      icon="leading"
      className="text-xs w-fit"
      onClick={handleViewAppointment}
    >
      <BookOpen size={8} />
      {t('PsychologistPatients.manageAppointment.cta')}
    </Button>
  );
};
